import React from 'react';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'default',
  className = '', 
  disabled = false,
  loading = false,
  icon,
  iconPosition = 'left',
  onClick,
  type = 'button',
  fullWidth = false,
  ...props 
}) => {
  const baseClasses = "inline-flex items-center justify-center font-semibold rounded-xl transition-all duration-300 ease-smooth focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed";
  
  const variantClasses = {
    primary: "bg-primary text-white hover:bg-primary/90 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5",
    secondary: "bg-secondary text-white hover:bg-secondary/90 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5",
    white: "bg-white text-primary hover:bg-gray-50 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5",
    outline: "border-2 border-primary text-primary hover:bg-primary hover:text-white",
    ghost: "text-primary hover:bg-primary/10",
    danger: "bg-error text-white hover:bg-error/90 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5",
    success: "bg-success text-white hover:bg-success/90 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5",
  };

  const sizeClasses = {
    small: "px-4 py-2 text-sm rounded-lg",
    default: "px-6 py-3 text-base",
    large: "px-8 py-4 text-lg rounded-2xl",
  };

  const widthClasses = fullWidth ? "w-full" : "";

  const classes = [
    baseClasses,
    variantClasses[variant],
    sizeClasses[size],
    widthClasses,
    className
  ].filter(Boolean).join(' ');

  const IconComponent = icon;

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      onClick={onClick}
      {...props}
    >
      {loading ? (
        <div className="flex items-center">
          <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Loading...
        </div>
      ) : (
        <div className="flex items-center">
          {icon && iconPosition === 'left' && <IconComponent className="mr-2 h-5 w-5" />}
          {children}
          {icon && iconPosition === 'right' && <IconComponent className="ml-2 h-5 w-5" />}
        </div>
      )}
    </button>
  );
};

export default Button;
